<template>
	<div class="shared-otp-channel-picker">
		<div class="shared-otp-channel-picker__grid">
			<o-card
				v-tooltip="setup.smsDisabledTooltip"
				class="shared-otp-channel-picker__card"
				:class="{
					'shared-otp-channel-picker__card--disabled': setup.smsDisabled,
					'shared-otp-channel-picker__card--selected': setup.isSmsSelected,
				}"
				:selected="setup.isSmsSelected"
				@click="setup.selectSms()">
				<div class="shared-otp-channel-picker__content">
					<o-icon
						class="shared-otp-channel-picker__icon"
						font-icon="icon-mail-chat-two-bubbles-square"/>
					<div class="shared-otp-channel-picker__text">
						<span class="shared-otp-channel-picker__label">{{ setup.$t("signature.otp.channel.sms") }}</span>
						<small class="shared-otp-channel-picker__description">{{ setup.phoneFormatted || setup.$t("signature.otp.channel.sms.noPhone") }}</small>
					</div>
				</div>
			</o-card>
			<o-card
				class="shared-otp-channel-picker__card"
				:class="{
					'shared-otp-channel-picker__card--selected': setup.isMailSelected,
				}"
				:selected="setup.isMailSelected"
				@click="setup.selectMail()">
				<div class="shared-otp-channel-picker__content">
					<o-icon
						class="shared-otp-channel-picker__icon"
						font-icon="icon-mail-send-email-envelope"/>
					<div class="shared-otp-channel-picker__text">
						<span class="shared-otp-channel-picker__label">{{ setup.$t("signature.otp.channel.mail") }}</span>
						<small class="shared-otp-channel-picker__description">{{ setup.email }}</small>
					</div>
				</div>
			</o-card>
		</div>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedOtpChannelPickerEmits, SharedOtpChannelPickerProps } from './SharedOtpChannelPickerSetup';
import SharedOtpChannelPickerSetup from './SharedOtpChannelPickerSetup';
const emits = defineEmits<SharedOtpChannelPickerEmits>() as SharedOtpChannelPickerEmits;
const props = withDefaults(defineProps<SharedOtpChannelPickerProps>(), SharedOtpChannelPickerSetup.defaultProps);
const setup = new SharedOtpChannelPickerSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
@import "@/styles/mixins.less";

.shared-otp-channel-picker {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	max-width: 32rem;
	margin: 0 auto;

	&__grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 0.75rem;
	}

	&__card {
		cursor: pointer;
		transition: border-color 0.15s ease;

		&--disabled {
			cursor: not-allowed;
			opacity: 0.5;
		}
	}

	&__content {
		.flex-align(flex-start, center);

		flex-direction: row;
		gap: 0.75rem;
		padding: 1rem;
	}

	&__icon {
		flex-shrink: 0;
		font-size: 1.5rem;
		color: var(--info);
	}

	&__text {
		.flex-align(flex-start, flex-start);

		flex: 1;
		flex-direction: column;
		gap: 0.125rem;
		min-width: 0;
	}

	&__label {
		font-size: 0.95rem;
		font-weight: 600;
		color: var(--grey-darker);
	}

	&__description {
		overflow: hidden;
		max-width: 100%;
		font-size: 0.8rem;
		color: var(--grey-dark);
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}

@media (width <= 36rem) {
	.shared-otp-channel-picker__grid {
		grid-template-columns: 1fr;
	}
}
</style>
